window.$ = window.jQuery = require('jquery');
var slick = require('slick.js');
var WebFont = require('exports?WebFont!webfontloader/webfontloader');
var Masonry = require('masonry/dist/masonry.pkgd');
var Datepicker = require('bootstrap-datepicker/dist/js/bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min');

// Bootstrap Components
var transition = require('bower_components/bootstrap-sass-official/vendor/assets/javascripts/bootstrap/transition');
var collapse = require('bower_components/bootstrap-sass-official/vendor/assets/javascripts/bootstrap/collapse');
var dropdown = require('bower_components/bootstrap-sass-official/vendor/assets/javascripts/bootstrap/dropdown');

/*
WebFont.load({
    google: {
        families: ['Lato:300,400,300italic:latin']
    }
});
*/

$(function() {

    var isEdit = $('body').hasClass('esy-edit');

    $('.date-field').datepicker({
        language: "de",
        format: "dd.mm.yyyy",
        todayHighlight: true,
        toggleActive: true
    });

    $('.slideshow').slick({
        infinite: true,
        speed: 300,
        lazyLoad: 'ondemand',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
    });

    $('.slideshow-locations').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        }]
    });

    $('.slideshow-rooms').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        slidesToShow: 4,
        lazyLoad: 'ondemand',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        }]
    });

    $('.slideshow-details .slideshow-main').slick({
        infinite: true,
        speed: 300,
        lazyLoad: 'ondemand',
        fade: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        asNavFor: '.slideshow-details .slideshow-thumbs'
    });

    $('.slideshow-details .slideshow-thumbs').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        slidesToShow: 4,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        asNavFor: '.slideshow-details .slideshow-main',
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        }]
    });

    $('.slideshow-gallerie .slideshow-main').slick({
        infinite: true,
        speed: 300,
        lazyLoad: 'ondemand',
        fade: true,
        dots: false,
        arrows: false,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        asNavFor: '.slideshow-gallerie .slideshow-thumbs'
    });

    $('.slideshow-gallerie .slideshow-thumbs').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        slidesToShow: 4,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        asNavFor: '.slideshow-gallerie .slideshow-main',
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        }]
    });

    $('.select-list select').on('input change blur click', function(e) {
        var $this = $(this);
        $this.parent().children('span').html($this.find('option:selected').text());
    }).trigger('change');

    if(!isEdit) {
        $('.speisekarte .collapsible .header').on('click', function(e){
            e.preventDefault();
            $(this).parent().toggleClass('in');
        });
    } else {
        $('.speisekarte .collapsible').addClass('in');
    }

    $('.masonry').masonry({
        itemSelector: '.item',
        columnWidth: function( containerWidth ) {
            var w = $('html, body').width();
            if(w < 992) {
                return Math.ceil((containerWidth-30) / 2);
            }

            return Math.ceil((containerWidth-30) / 4);
        }
    });

    $('.nav a.dropdown-toggle').each(function() {
        $(this)
        .data('toggle', 'dropdown')
        .attr('role', 'button')
        .attr('aria-expanded', 'false')
        .append('<span class="caret"></span>');
        /*
        .on('click', function(e) {
            e.preventDefault();
            $(this).dropdown('toggle');
        });
        */
    });

    $('.map .overlay').on('click', function(e) {
        console.log(e.target);
        $(e.target).hide();
    });

    /*
    $('.map').each(function(i, el) {
        var map;
        var mapOptions = {
            zoom: 16,
            scrollwheel: false,
            center: new google.maps.LatLng(51.4797878, 6.8647609)
        };

        map = new google.maps.Map(el, mapOptions);
    });
    */

});



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/main.js
 ** module id = 0
 ** module chunks = 0
 **/